import React from 'react';
import { motion } from 'framer-motion';
export function ContactUs() {
  return <section id="contact-us" className="py-24 bg-white overflow-hidden" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4" data-id="element-49">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-50">
          {/* Left Side: Image with decorative backgrounds */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-51">
            {/* Decorative light blue background block */}
            <div className="absolute -left-12 -top-12 w-64 h-[120%] bg-[#225274]/5 -z-10 rounded-3xl" data-id="element-52" />

            <div className="relative" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/bv2bbesY6c35gbKaUfxi7D/pasted-image.jpg" alt="Dental Professional at work" className="rounded-[40px] shadow-2xl relative z-10 w-full object-cover aspect-[4/3]" data-id="element-54" />
              {/* Decorative dark blue block behind bottom right */}
              <div className="absolute -right-8 -bottom-8 w-32 h-32 bg-[#225274] rounded-2xl -z-10" data-id="element-55" />
            </div>
          </motion.div>

          {/* Right Side: Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-56">
            {/* Contact Us Badge */}
            <div className="inline-flex items-center gap-2 bg-[#cef4d2]/50 px-4 py-2 rounded-full mb-8" data-id="element-57">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center overflow-hidden border border-[#54c595]/30" data-id="element-58">
                <img src="https://cdn.magicpatterns.com/uploads/87Bf7g3SZwHtLWVCAELi4y/pasted-image.png" alt="Tooth Icon" className="w-6 h-6 object-contain" data-id="element-59" />
              </div>
              <span className="text-[#225274] font-bold text-sm tracking-widest uppercase" data-id="element-60">
                Contact Us
              </span>
            </div>

            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-slate-50" data-id="element-61">
              <form className="space-y-6" data-id="element-62">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-63">
                  <div className="space-y-2" data-id="element-64">
                    <label className="text-sm font-bold text-[#225274]/70 ml-1" data-id="element-65">
                      First name
                    </label>
                    <input type="text" placeholder="Enter your first name" className="w-full bg-[#cef4d2]/30 border-none rounded-2xl py-4 px-6 text-[#225274] placeholder:text-[#225274]/30 focus:ring-2 focus:ring-[#54c595] transition-all" data-id="element-66" />
                  </div>
                  <div className="space-y-2" data-id="element-67">
                    <label className="text-sm font-bold text-[#225274]/70 ml-1" data-id="element-68">
                      Email *
                    </label>
                    <input type="email" placeholder="Enter your email" className="w-full bg-[#cef4d2]/30 border-none rounded-2xl py-4 px-6 text-[#225274] placeholder:text-[#225274]/30 focus:ring-2 focus:ring-[#54c595] transition-all" data-id="element-69" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-70">
                  <label className="text-sm font-bold text-[#225274]/70 ml-1" data-id="element-71">
                    Subject
                  </label>
                  <input type="text" placeholder="e.g., Support" className="w-full bg-[#cef4d2]/30 border-none rounded-2xl py-4 px-6 text-[#225274] placeholder:text-[#225274]/30 focus:ring-2 focus:ring-[#54c595] transition-all" data-id="element-72" />
                </div>

                <div className="space-y-2" data-id="element-73">
                  <label className="text-sm font-bold text-[#225274]/70 ml-1" data-id="element-74">
                    Write a message
                  </label>
                  <textarea rows={4} placeholder="Enter text here" className="w-full bg-[#cef4d2]/30 border-none rounded-2xl py-4 px-6 text-[#225274] placeholder:text-[#225274]/30 focus:ring-2 focus:ring-[#54c595] transition-all resize-none" data-id="element-75" />
                </div>

                <div className="pt-4 text-center" data-id="element-76">
                  <button type="submit" className="bg-[#225274] hover:bg-[#1a3d58] text-white px-12 py-4 rounded-full font-bold transition-all shadow-lg shadow-[#225274]/20 uppercase tracking-widest" data-id="element-77">
                    Send
                  </button>
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}